module.exports = __webpack_public_path__ + "img/mapp.03aea8eb.png";